const sortBySortValue = (a, b) => {
  if (a.sort < b.sort) {
    return -1;
  }
  if (a.sort > b.sort) {
    return 1;
  }
  return 0;
};

// for these slugs, we want to remove the parent slug:
// { slug: 'calendar/new-releases/sneakers/a-sneakers } becomes { slug: 'sneakers/a-sneakers' }
const slugsToSplitByType = new Set([
  'navigation/category',
  'calendar/new-releases',
  'calendar/upcoming-releases',
]);

/**
 * [sortAndParseHeaderBreadcrumbs] removes the preceding type - 'navigation' or 'calendar'
 * part of the slug and sorts in by the sort value
 * {slug: 'navigation/brand/acne-studios} becomes {slug: 'brand/acne-studios'}
 * @param breadcrumbsArr
 * @param type
 */
export const sortAndParseHeaderBreadcrumbs = (breadcrumbsArr, type) => {
  return breadcrumbsArr.map((breadcrumb) => {
    if (!breadcrumb.children) {
      return;
    }

    const children = breadcrumb.children
      .map((child) => {
        if (slugsToSplitByType.has(breadcrumb.slug)) {
          return { ...child, slug: child.slug?.split(`${breadcrumb.slug as string}/`)?.[1] };
        }

        return { ...child, slug: child.slug?.split(`${type as string}/`)?.[1] };
      })
      .sort(sortBySortValue);

    return { ...breadcrumb, children };
  });
};
